<div class="dialog">
  <div class="profile-icon">
    <app-avatar [user]="state.guest" [tempName]="form.value.name"></app-avatar>
    @if (gallery) {
      <app-badge color="primary" [stroke]="true">
        @if (galleryPermissions()?.can_review_if_authenticated) {
          Reviewer
        } @else if (!galleryPermissions().can_edit) {
          View-only
        }
      </app-badge>
    }
  </div>
  @if (!isAnonymous) {
    <h1 class="no-desc">Your Visitor Profile</h1>
  } @else {
    <h1>{{ anonymousGuestName }}</h1>
    <p class="description">Add your info to let others know who is leaving feedback – No signup required.</p>
  }
  <form [formGroup]="form" #ngForm="ngForm" [class.submitted]="ngForm.submitted" (ngSubmit)="save()">
    <app-input-field [control]="form.controls.name" [big]="true">
      <input
        type="text"
        formControlName="name"
        data-test-id="guest-name"
        autocomplete="off"
        data-1p-ignore="true"
        data-lpignore="true"
        appAutofocus
      />
      <label>Name</label>
    </app-input-field>
    <app-input-field [control]="form.controls.email" [big]="true">
      <input type="email" formControlName="email" data-test-id="guest-email" />
      <label>Email (Optional)</label>
    </app-input-field>
    <button
      appButton
      name="confirm"
      class="confirm-button"
      location="guest-profile-dialog"
      color="primary"
      height="3"
      weight="bold"
      spacing="full"
      data-test-id="guest-cta"
      shape="round"
    >
      @if (isAnonymous) {
        <span [class.hidden-text]="saving()">Add Information</span>
      } @else {
        <span [class.hidden-text]="saving()">Update Info</span>
      }
      @if (saving()) {
        <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
      }
    </button>
  </form>
  @if (isAnonymous) {
    <button
      appButton
      name="stay-incognito"
      location="guest-profile-dialog"
      class="stay-incognito-button"
      color="simple"
      data-test-id="guest-stay-incognito"
      shape="round"
      spacing="full"
      (click)="close()"
    >
      Stay Anonymous
    </button>
  }
  @if (growthBook.isOn('allow-debug-set-instant-for-guest')) {
    <button (click)="devOnlySetDigestToInstantly()">Set digest to instant (DEV ONLY)</button>
  }
</div>
